module.exports = __webpack_public_path__ + "static/banner-b970463106e65d5a2526b423b1d06ffd.png";